export default __webpack_public_path__ + "static/media/Cheerleader.7d16ce44.gif";